export const PRODUCTS_FORM_INFOS = {
  power: {
    radioLabel: 'Strom',
    title: 'Person im Haushalt',
    titlePlural: 'Personen im Haushalt',
    label: 'Jahresverbrauch',
    editorTitle: 'Wie hoch ist Ihr jährlicher Stromverbrauch?',
    buttonText: 'Stromtarife berechnen',
    options: [
      { label: '1.590 kWh (1 Person)', value: '1590' },
      { label: '2.275 kWh (2 Personen)', value: '2275' },
      { label: '3.000 kWh (3 Personen)', value: '3000' },
      { label: '3.940 kWh (4 Personen)', value: '3940' },
      { label: '4.410 kWh (5 Personen)', value: '4410' },
    ],
    defaultValue: '2275',
    min: 1000,
    max: 200000,
    configuratorPath: '/sugr/strom',
  },
  gas: {
    radioLabel: 'Gas',
    buttonText: 'Gastarife berechnen',
    title: 'Wohnfläche im Haushalt',
    titlePlural: 'Wohnfläche im Haushalt',
    label: 'Jahresverbrauch',
    editorTitle: 'Wie hoch ist Ihr jährlicher Gasverbrauch?',
    options: [
      { label: '6.250 kWh (50 m²)', value: '6250' },
      { label: '10.000 kWh (80 m²)', value: '10000' },
      { label: '12.500 kWh (100 m²)', value: '12500' },
      { label: '15.000 kWh (120 m²)', value: '15000' },
      {label: '18.750 kWh (150 m²)', value: '18750' },
    ],
    defaultValue: '10000',
    min: 1,
    max: 30000,
    configuratorPath: '/sugr/gas',
  },
  combined: {
    radioLabel: 'Strom & Gas',
    buttonText: 'Tarife berechnen',
    title: '',
    titlePlural: '',
    label: '',
    editorTitle: '',
    options: [],
    configuratorPath: '/sugr/strom-gas',
  },
};
